/**
 * Created by BTsergey on 10/12/2017.
 */

(function btBrokerErrorClosure() {
  'use strict';

  angular
    .module('ecapp')
    /**
     * This directive just display select broker error.
     *
     * @ngdoc directive
     * @name btBrokerError
     * @memberOf ecapp
     */
    .directive('btBrokerError', [
      '$templateCache',
      '$state',
      '$ionicHistory',
      function ($templateCache, $state, $ionicHistory) {
        return {
          restrict: 'E',
          transclude: true,
          scope: null,
          template: $templateCache.get('directives/broker/bt-broker-error.html'),
          controller: [
            '$scope',
            function ($scope) {
              $ionicHistory.nextViewOptions({
                disableBack: true,
              });

              $scope.redirect = function () {
                console.log('BrokerError: try to open ecapp.app.broker');
                $state.go('ecapp.app.broker');
              };
            },
          ],
        };
      },
    ]);
})();
